import PageHero from "@/components/PageHero";
import CTABanner from "@/components/CTABanner";
import { LocationAdvantages } from "@/components/HomeExtras";

export default function KonumPage() {
  return (
    <>
      <PageHero
        overline="Konum Avantajları"
        titleLines={["Denize Sıfır,", "Şehrin Kalbinde"]}
        description="Atakum sahiline yürüme mesafesinde; ulaşımı kolay, sosyal ve güvenli bir çevrede konumlanıyoruz."
      />
      <LocationAdvantages />
      <CTABanner />
    </>
  );
}
